// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a9b9d6e1dd5f3ddf86dc","655":"4fb7baf445b7f96f90ed"}[chunkId] + ".js";
};